<template>
    <Card class="DashboardStatsCard">
        <div class="circle">
            <Icon :name="icon"/>
        </div>

        <div class="main">
            <span>{{ Number.isFinite(amount) ? amount : '-' }}</span>
            <h5>{{ title }}</h5>
        </div>
    </Card>
</template>

<script>
import Card from '@/components/Card';

export default {
    name: 'DashboardStatsCard',

    components: { Card },

    props: {
        title: { type: String, required: true },
        amount: { type: Number },
        icon: { type: String, required: true },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.DashboardStatsCard {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: $grid-gutter-width;

    .circle {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        background-color: $bg-color-4;
        position: relative;
        overflow: hidden;

        .Icon {
            @include absolute-center(y);
            left: -10%;
            font-size: 50px;
            color: #fff;
        }
    }

    .main {
        margin-right: 5px;
        text-align: right;

        span {
            font-size: 36px;
            font-weight: $font-weight-light;
        }
    }
}
</style>
